export default __webpack_public_path__ + "static/media/ar_image.0df8d0d8.png";